import { createContext, useContext } from 'react';
import { TutorialStep } from './types';
import ThemeManager from '../components/themeManager';

export interface GetStartedContextType {
  formdata: TutorialStep[];
  showLoader: boolean;
  allActionCompleted: boolean;
  completedPercentage: number;
  themeManager: ThemeManager;
  handleCriteriaClick: (id: any, url: string) => Promise<void | boolean>;
  dropdowns: boolean[];
  setDropdown: React.Dispatch<React.SetStateAction<boolean[]>>;
  template: number;
  isImageOpen: boolean;
  iconUrls: string[];
  ButtonType: "Arrow" | "Buttons";
  allowMultiClick: boolean;
  onClose?: () => void;
}


export const GetStartedContext = createContext<GetStartedContextType>({} as GetStartedContextType);

export const useGetStarted = () => {
  const context = useContext(GetStartedContext);
  if (!context) {
    throw new Error('useGetStarted must be used within a GetStartedProvider');
  }
  return context;
};